import { useMutation } from "@tanstack/react-query";

import { SATOSPortal } from "@/DataAdapter/SATOSPortal";

export const useMutateArchiveProcedurePdf = () => {
	const { mutateAsync: createArchivedProcedurePdf } = useMutation({
		mutationFn: (procedureId: number) => {
			return SATOSPortal.CreateArchivedProcedurePdf(procedureId);
		},
	});

	return createArchivedProcedurePdf;
};
